import styled from '@emotion/styled';
import { Link } from '@reach/router';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const TextTypeStyledLink = styled(Link)`
  width: calc(100% / 3);
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-size: 16px;
  color: ${COLORS.seaBlue}!important;
  &:hover {
    background-color: ${COLORS.gray95};
  }
  cursor: pointer;
  &:not(:nth-child(3n)) {
    border-right: 1px solid #dfdfdf;
  }
  text-decoration: none;
  ${DOTTED_FOCUS};
`;
